export default "__VITE_ASSET__CxrDafqK__"